// extracted by mini-css-extract-plugin
module.exports = {"container":"_3M_Scl","wrapper":"SljFZz","logo":"EvW7Di","message":"_3cQFWX","mobile":"_3QRcX_"};